// Distritos de Portugal
export const DISTRITOS_PORTUGAL = [
    'Aveiro', 'Beja', 'Braga', 'Bragança', 'Castelo Branco',
    'Coimbra', 'Évora', 'Faro', 'Guarda', 'Leiria',
    'Lisboa', 'Portalegre', 'Porto', 'Santarém', 'Setúbal',
    'Viana do Castelo', 'Vila Real', 'Viseu',
    'Região Autónoma dos Açores', 'Região Autónoma da Madeira'
];
// Operadoras portuguesas
export const OPERADORAS_PORTUGAL = [
    'MEO', 'NOS', 'Vodafone', 'NOWO', 'Lycamobile', 'Outro'
];
